
import { Hoolduskava } from '@/models/Hoolduskava';
import { AxiosTeenus } from './axios-teenus';

export class HoolduskavaTeenus {

    public async minuHoolduskavaInfo(): Promise<Hoolduskava[]> {

        const axios = new AxiosTeenus();

        const response = await axios
            .get<Hoolduskava[]>(`/api/hoolduskava/hoolduskavainfo`);

        return response?.data;
    }
}